import { createContext, useContext } from 'react';

export type FillableBlanksContextType = {
  enableFillableBlanksV2?: boolean;
};

export const FillableBlanksContext = createContext<FillableBlanksContextType>({});

export const useFillableBlanksContext = () => useContext(FillableBlanksContext);
